import {useEffect} from 'react';
import {useAtomValue} from 'jotai';
import {themeModeAtom} from '@lib/atoms';
import {applyThemeMode, applyWorkspaceTheme} from '@lib/theme';
import {useActiveWorkspace, useWorkspace} from '@api/workspaces';

/**
 * Применяет оформление к DOM (рендерит null):
 *   - личный режим (light/dark/system) + слежение за системной темой;
 *   - тему активного воркспейса (палитра/радиус/шрифты/тени) ко всем участникам.
 *
 * Монтируется один раз в AppLayout. Режим дополнительно инициализируется рано в
 * main.tsx (bootstrapThemeMode) — здесь поддерживаем синхронизацию в рантайме.
 */
export const ThemeController = () => {
  const mode = useAtomValue(themeModeAtom);
  const {activeId} = useActiveWorkspace();
  const {data: workspace} = useWorkspace(activeId);
  const theme = workspace?.theme ?? null;

  // Режим + реакция на смену системной темы (только при mode === 'system').
  useEffect(() => {
    applyThemeMode(mode);
    if (mode !== 'system' || typeof window === 'undefined') return;
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    const onChange = () => applyThemeMode('system');
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [mode]);

  // Тема воркспейса (или сброс к дефолту, если темы нет).
  useEffect(() => {
    applyWorkspaceTheme(theme);
  }, [theme]);

  return null;
};
